module.exports = __webpack_public_path__ + "media/img/bg_slide-68fc7c1c.png";